import React, { useState } from "react";
import {
    useChangePassword,
    useCurrentUser,
    useMe,
    useUpdateMe,
} from "../actions/auth";
import "./style/input.css";
import log from "cslog";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { Alert, Button, Col, Form, Input, Row, Space } from "antd";
import Loading from "../common/Loading";
import UpdateProfile from "./UpdateProfile";
import ChangePassword from "./ChangePassword";
import ImagePicker from "../editor/imagepicker/ImagePicker";

function AccountSetting(onChange) {
    return (
        <>
            <UpdateProfile enable_footer={false} />
            <ChangePassword />
        </>
    );
}

export default AccountSetting;
